export default "__VITE_ASSET__BCWOW7$y__"